/**
 * 表单控件类型
 */
export var FormControlType;
(function (FormControlType) {
    /**
     * 标签
     */
    FormControlType[FormControlType["Label"] = 0] = "Label";
    /**
     * 单文本
     */
    FormControlType[FormControlType["Text"] = 1] = "Text";
    /**
     * 长文本
     */
    FormControlType[FormControlType["Textarea"] = 2] = "Textarea";
    /**
     * 日期
     */
    FormControlType[FormControlType["Date"] = 3] = "Date";
    /**
     * 数值
     */
    FormControlType[FormControlType["Number"] = 4] = "Number";
    /**
     * 单选
     */
    FormControlType[FormControlType["Radio"] = 5] = "Radio";
    /**
     * 复选
     */
    FormControlType[FormControlType["Checkbox"] = 6] = "Checkbox";
    /**
     * 下拉
     */
    FormControlType[FormControlType["Dropdown"] = 7] = "Dropdown";
    /**
     * 逻辑
     */
    FormControlType[FormControlType["Logic"] = 8] = "Logic";
    /**
     * 附件
     */
    FormControlType[FormControlType["Attachment"] = 9] = "Attachment";
    /**
     * 大附件
     */
    FormControlType[FormControlType["BigAttachment"] = 29] = "BigAttachment";
    /**
     * 图片
     */
    FormControlType[FormControlType["Image"] = 10] = "Image";
    /**
     * 位置
     */
    FormControlType[FormControlType["Location"] = 11] = "Location";
    /**
     * 日期范围
     */
    FormControlType[FormControlType["DateRange"] = 12] = "DateRange";
    /**
     * 数值范围
     */
    FormControlType[FormControlType["NumberRange"] = 13] = "NumberRange";
    /**
     * 地址
     */
    FormControlType[FormControlType["Address"] = 14] = "Address";
    /**
     * 签名
     */
    FormControlType[FormControlType["Signature"] = 15] = "Signature";
    /**
     * 基础控件times
     */
    FormControlType[FormControlType["Tips"] = 16] = "Tips";
    /**
     * 时间
     */
    FormControlType[FormControlType["Time"] = 17] = "Time";
    /**
     * 时间范围
     */
    FormControlType[FormControlType["TimeRange"] = 18] = "TimeRange";
    /**
 * 下拉框多选
 */
    FormControlType[FormControlType["DropdownMulti"] = 19] = "DropdownMulti";
    /**
     * 人员单选
     */
    FormControlType[FormControlType["StaffSelector"] = 50] = "StaffSelector";
    /**
     * 人员多选
     */
    FormControlType[FormControlType["StaffMultiSelector"] = 51] = "StaffMultiSelector";
    /**
     * 部门单选
     */
    FormControlType[FormControlType["DepartmentSelector"] = 60] = "DepartmentSelector";
    /**
     * 部门多选
     */
    FormControlType[FormControlType["DepartmentMultiSelector"] = 61] = "DepartmentMultiSelector";
    /**
     * 混合
     */
    FormControlType[FormControlType["StaffDeptMixed"] = 62] = "StaffDeptMixed";
    /**
     * 审批意见
     */
    FormControlType[FormControlType["ApprovalOpinion"] = 70] = "ApprovalOpinion";
    /**
     * 关联单选
     */
    FormControlType[FormControlType["RelevanceForm"] = 80] = "RelevanceForm";
    /**
     * 关联多选
     */
    FormControlType[FormControlType["RelevanceFormEx"] = 81] = "RelevanceFormEx";
    /**
     * 反向关联
     */
    FormControlType[FormControlType["ReverseRelevance"] = 90] = "ReverseRelevance";
    /**
     * 系统-流水号
     */
    FormControlType[FormControlType["SequenceNo"] = 100] = "SequenceNo";
    /**
     * 系统-创建人
     */
    FormControlType[FormControlType["CreateBy"] = 101] = "CreateBy";
    /**
     * 系统-创建人部门
     */
    FormControlType[FormControlType["CreateByParentId"] = 102] = "CreateByParentId";
    /**
     * 系统-修改人
     */
    FormControlType[FormControlType["ModifyBy"] = 103] = "ModifyBy";
    /**
     * 系统-创建时间
     */
    FormControlType[FormControlType["CreatedTime"] = 104] = "CreatedTime";
    /**
     * 系统-修改时间
     */
    FormControlType[FormControlType["ModifiedTime"] = 105] = "ModifiedTime";
    /**
     * 系统-拥有者
     */
    FormControlType[FormControlType["OwnerId"] = 106] = "OwnerId";
    /**
     * 系统-其他
     */
    FormControlType[FormControlType["SystemOther"] = 107] = "SystemOther";
    /**
     * 系统-单据状态
     */
    FormControlType[FormControlType["SequenceStatus"] = 108] = "SequenceStatus";
    /**
     * 布局-分组标题
     */
    FormControlType[FormControlType["Group"] = 200] = "Group";
    /**
     * 子表
     */
    FormControlType[FormControlType["Sheet"] = 201] = "Sheet";
    /**
     * 描述说明
     */
    FormControlType[FormControlType["Description"] = 202] = "Description";
    /**
     * 表单标题
     */
    FormControlType[FormControlType["Title"] = 203] = "Title";
    /**
     * 子表统计
     */
    FormControlType[FormControlType["SheetStatistic"] = 300] = "SheetStatistic";
    /**
     * HTML片段
     */
    FormControlType[FormControlType["Html"] = 400] = "Html";
    /**
     * 标签页
     */
    FormControlType[FormControlType["Tabs"] = 500] = "Tabs";
    /**
     * 标签页面板
     */
    FormControlType[FormControlType["TabsPanel"] = 501] = "TabsPanel";
    FormControlType[FormControlType["ExTree"] = 89] = "ExTree";
})(FormControlType || (FormControlType = {}));
